import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/Dashboard.css"
import Checkbox from '../Components/Checkbox.js';
import Caret from 'react-icons/lib/fa/caret-right';
import RightArrow from '../images/rightArrow2.png'
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class AppointmentBlurb extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appointment: props.appointment
    }
  }
  componentWillReceiveProps(nextProps) {
  }
  render() {
    var appt = this.state.appointment
    var apptVehicles = []
    if(appt){
      appt.appointment_vehicles.forEach(function(av){
        var vehicleType = 'sedan'
        apptVehicles.push(<div className="dashboardBlurb">
                              <img className="stockImage"src={av.vehicle.stock_image_url} onError={(e)=>{e.target.onerror = null; e.target.src=`https://s3.amazonaws.com/spiffy-conductor-vehicle-images/generic/${vehicleType}.png`}}></img>
                            <div>
                              <h5 className="carPackage">{av.vehicle.summary}</h5>
                              <p className="carPackage">{av.display_title}</p>
                              <p className="apptSummary">{appt.status_description}</p>
                              <p className="smallGray">{appt.start_at_formatted}</p>
                              <p className="smallGray">{appt.address.street}</p>
                              <p className="smallGray">{appt.address.city}</p>
                            </div>
                            <img src={RightArrow} className="arrow"></img>
                          </div>)
      })
    }
    return (
      <div className="card upgradeCard dashboardBlurb">
        {apptVehicles}
      </div>
    )
  }
}
export default AppointmentBlurb



// WEBPACK FOOTER //
// ./src/Components/AppointmentBlurb.js